import React, { useCallback, useRef, useState } from 'react';
import {
  getMarket,
  getSavedSearchesNew,
  getSearch,
  Request,
  SaveApiResMessage,
} from '@/actions';
import { noScroll, removeNoScroll } from '@/actions/Helper';
import { ParseMarketPlaceForm } from '@/actions/ParseData';
import qs from 'query-string';
import PageContainerAB from '@/components/PageContainerAB/pageContainer';
import ReservePupop from './ReservePupop';
import IconButton from '@/ctComponents/IconButton';
import SearchResultMapView from './MapView';
import SearchResultListView from './ListView';
import SearchFilter from './SearchFilter';
import { useInfiniteScroll } from '@/hooks/useInfiniteScroll';

const SearchEmpty = ({ history }) => {
  const [view, setView] = useState('map');
  const [reserveInformation, setReserveInformation] = useState({
    item: null,
    open: false,
  });
  const [formData, setFormData] = useState({
    specification_id: null,
    company_id: null,
    count: null,
    date: new Date(),
    loc: null,
    prefrence: false,
    chassis: {
      own: true,
      pool: true,
    },
  });

  const fetchApi = useCallback((page) => getMarket(page), []);

  const { items: DATA, loading } = useInfiniteScroll(fetchApi);

  const fetchSavedSearches = useCallback(
    (page) => getSavedSearchesNew({ page }),
    []
  );

  const {
    items: savedSearches,
    loading: savedSearchesLoading,
    refetch: refetchSavesSearches,
  } = useInfiniteScroll(fetchSavedSearches);

  const submitSearch = () => {
    for (let el in formData) {
      if (el !== 'prefrence' && !formData[el]) {
        SaveApiResMessage({
          title: 'Action Required',
          message:
            'Required fields must be completed to proceed with the search.',
          mode: 'warning',
        });
        return;
      }
      if (el === 'chassis' && !formData[el].own && !formData[el].pool) {
        SaveApiResMessage({
          title: 'Warning',
          message: 'Error, Please Select Chassis.',
          mode: 'warning',
        });
        return;
      }
    }

    history.push(
      '/search-detail/empty?' + qs.stringify(ParseMarketPlaceForm(formData))
    );
  };

  const setForm = (it, val) => setFormData({ ...formData, [it]: val });

  const req = ({ id, num }) => {
    Request({
      inventory_id: id,
      count: num,
    })
      .then((res) => {
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: res,
          mode: 'success',
        });
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  const closeReserve = () => {
    removeNoScroll();
    setReserveInformation({
      item: null,
      open: false,
    });
  };

  const openReserve = (item) => {
    noScroll();

    if (item)
      setReserveInformation({
        item: {
          ...item,
          count:
            reserveInformation.item?.id === item.id
              ? reserveInformation.item.count
              : item.count,
        },
        open: true,
      });
    else
      setReserveInformation((pre) => ({
        ...pre,
        open: true,
      }));
  };

  const activeNotify = () => {
    const params = {
      count: formData.count,
      date: formData.date,
      lat: formData.loc.value.lat,
      long: formData.loc.value.lng,
      address: formData.loc.value.address,
      city: formData.loc.value.city,
      size: formData.specification_id.value,
      ssl: formData.company_id.value,
      chases: formData.chassis.own
        ? 'own'
        : formData.chassis.pool
        ? 'pool'
        : '',
      save_search: true,
    };
    getSearch(params)
      .then((res) => {
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: 'success',
          mode: 'success',
        });
        refetchSavesSearches();
      })
      .catch((err) => {
        if (err.includes('No Inventory has been found for this search')) {
          SaveApiResMessage({
            title: null,
            message:
              'You will be notified when a matching container is added to the platform .',
            mode: 'success',
          });
          refetchSavesSearches();
        } else {
          SaveApiResMessage({
            title: 'Error',
            message: err,
            mode: 'warning',
          });
        }
      });
  };

  return (
    <PageContainerAB mainPage minWidth={'unset'} title="Search for Empties">
      {reserveInformation.open && (
        <ReservePupop
          item={reserveInformation.item}
          req={req}
          num={reserveInformation.item.count}
          CloseReserve={closeReserve}
        />
      )}

      <SearchFilter
        formData={formData}
        setForm={setForm}
        onSubmit={submitSearch}
        activeNotify={activeNotify}
      />

      <div className="flex sm:flex-row flex-col justify-between items-end shrink-0 my-4">
        <div>
          <h3 className="text-black text-xl font-bold m-0 ">Search Results</h3>
          <p className="text-secondary-text text-lg m-0 ">
            View the latest empty container offers for Street Turn and reserve
            directly from the list.
          </p>
        </div>
        <IconButton
          text="Switch View"
          icon="grid"
          color="#131617"
          onClick={() => setView(view === 'list' ? 'map' : 'list')}
          style={{
            height: 40,
          }}
        />
      </div>
      <div className="lg:grid lg:grid-cols-3 2xl:grid-cols-2 flex flex-col-reverse gap-4  ">
        {view === 'list' ? (
          <SearchResultListView
            loading={loading}
            DATA={DATA}
            openReserve={openReserve}
            setReserveInformation={setReserveInformation}
            reservedItem={reserveInformation.item}
            activeNotify={activeNotify}
          />
        ) : (
          <SearchResultMapView
            loading={loading}
            DATA={DATA}
            openReserve={openReserve}
            setReserveInformation={setReserveInformation}
            savedSearches={savedSearches}
            savedSearchesLoading={savedSearchesLoading}
            refetchSavesSearches={refetchSavesSearches}
            reservedItem={reserveInformation.item}
          />
        )}
      </div>
    </PageContainerAB>
  );
};

export default SearchEmpty;
